// Each operation owns its controller, timeout and cleanup. The registry exists
// only to cancel all outstanding work on context changes, retry or unmount.
export function createBoundedVoiceRequests(timeoutMs = 30000) {
  const outstanding = new Set()
  return {
    run(request) {
      const controller = new AbortController()
      let timer, cancel
      const interrupted = new Promise((_, reject) => {
        cancel = () => {
          clearTimeout(timer)
          reject(Object.assign(new Error('voice_cancelled'), { code: 'voice_cancelled' }))
          controller.abort()
        }
        timer = setTimeout(() => {
          reject(Object.assign(new Error('voice_timeout'), { code: 'voice_timeout' }))
          controller.abort()
        }, timeoutMs)
      })
      outstanding.add(cancel)
      const transport = Promise.resolve().then(() => {
        if (controller.signal.aborted) throw Object.assign(new Error('voice_cancelled'), { code: 'voice_cancelled' })
        return request(controller.signal)
      })
      return Promise.race([transport, interrupted]).finally(() => {
        clearTimeout(timer)
        outstanding.delete(cancel)
      })
    },
    cancelAll() {
      for (const cancel of outstanding) cancel()
      outstanding.clear()
    },
  }
}
